import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ButtonEventsService {
  logo = new EventEmitter<void>();

  logout = new EventEmitter<void>();
  logoutLabel = new BehaviorSubject<string>('');

  user = new EventEmitter<void>();
  myProfileLabel = new BehaviorSubject<string>('');

  applyLabel = new BehaviorSubject<string>('');
  cancelLabel = new BehaviorSubject<string>('');

  constructor() {}
}
